import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum PaymentPrescriptionStatusId {
  PAID = 'paid',
  TO_BE_SENT = 'to-be-sent',
  TO_BE_PAID = 'to-be-paid',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
}

export type PaymentPrescriptionStatusColor =
  | Color.POSITIVE
  | Color.INFO
  | Color.WARNING
  | Color.NEGATIVE
  | Color.GREY_600

export class PaymentPrescriptionStatus extends Codebook<PaymentPrescriptionStatusId> {
  static readonly PAID = new PaymentPrescriptionStatus(
    PaymentPrescriptionStatusId.PAID,
    () => $t('Paid'),
    Color.POSITIVE,
    'check',
    Color.POSITIVE,
  )
  static readonly TO_BE_SENT = new PaymentPrescriptionStatus(
    PaymentPrescriptionStatusId.TO_BE_SENT,
    () => $t('To be send'),
    Color.INFO,
    null,
    null,
    'hourglass',
    Color.INFO,
  )
  static readonly TO_BE_PAID = new PaymentPrescriptionStatus(
    PaymentPrescriptionStatusId.TO_BE_PAID,
    () => $t('To be paid'),
    Color.WARNING,
    'hourglass',
    Color.WARNING,
  )
  static readonly EXPIRED = new PaymentPrescriptionStatus(
    PaymentPrescriptionStatusId.EXPIRED,
    () => $t('Expired'),
    Color.NEGATIVE,
    'xmark',
    Color.NEGATIVE,
  )
  static readonly CANCELLED = new PaymentPrescriptionStatus(
    PaymentPrescriptionStatusId.CANCELLED,
    () => $t('Cancelled'),
    Color.GREY_600,
    null,
    null,
  )

  private constructor(
    public readonly id: PaymentPrescriptionStatusId,
    public readonly name: () => string,
    public readonly color: PaymentPrescriptionStatusColor,
    public readonly paymentIcon: null | string,
    public readonly paymentIconColor: null | Color.POSITIVE | Color.WARNING | Color.NEGATIVE,
    public readonly sendingIcon: string = 'check',
    public readonly sendingIconColor: Color.POSITIVE | Color.INFO = Color.POSITIVE,
  ) {
    super(id)
  }
}
